import React from 'react'

import ZoomMap from '../components/ZoomMap/ZoomMap'
import StatisticPreview from '../components/StatisticPreview/StatisticPreview'

/**
 * Hidden object
 */
class HiddenObjects extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {
            blockData: { t, enableTimer },
        } = this.props
        return (
            <div className={`block __${t}`}>
                {enableTimer && <StatisticPreview />}
                <ZoomMap {...this.props} />
            </div>
        )
    }
}

export default HiddenObjects
